<template>
    <button
        :id="id"
        :class="{ disabled, loading, secondary, fetching }"
        :disabled="disabled || loading"
        class="button-action"
        :type="canSubmit ? 'submit' : 'button'"
        :data-testid="testId"
        @click="emit('click')"
    >
        <div class="button-action-content">
            <transition
                mode="out-in"
                name="button-text-transition"
            >
                <div
                    v-if="!loading && !fetching"
                    :key="label"
                >{{ label }}</div>

                <div
                    v-else-if="!fetching"
                    key="loading"
                >
                    <LoadingCircle large />
                </div>
            </transition>
        </div>

        <div
            :class="{ active: fetching }"
            class="button-action-fetching"
        />
    </button>
</template>

<script setup lang="ts">
import LoadingCircle from 'widget-components/components/LoadingCircle/LoadingCircle.vue'
import { computed } from 'vue'
import { flattenedBlocks } from 'widget-components/integrations/CustomPage/blocks-state'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    buttonType?: 'NEXT' | 'PREV' | 'CLOSE'
    disabled?: boolean
    loading?: boolean
    secondary?: boolean
    fetching?: boolean
    label?: string
    testId?: string
}>()

const emit = defineEmits(['click'])

const canSubmit = computed(() => {
    const submittableButtons = flattenedBlocks.value.filter(b => b.type === 'ACTION_BUTTON' && b.buttonType !== 'PREV')
    return submittableButtons.length === 1 && props.id === submittableButtons[0].id
})

</script>

<style lang="sass" scoped>
@import "./ActionButton.sass"
</style>
